import { Brand } from '@blade/std-lib'

export const ActivityIdTypeId = 'tradebot-tma/ActivityId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ActivityIdTypeId = typeof ActivityIdTypeId

export type ActivityId = Brand.Branded<string, ActivityIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityId = Brand.nominal<ActivityId>()
